import api from './api';

// Le Fil — réseau social d'entreprise (backend/src/routes/fil.js)
const filApi = {
  getStatus:       ()             => api.get('/fil/status'),
  setStatus:       (enabled)      => api.put('/fil/status', { enabled }),
  getContexte:     ()             => api.get('/fil/contexte'),
  getNonLus:       ()             => api.get('/fil/non-lus'),
  marquerVu:       ()             => api.post('/fil/vu'),
  getPosts:        (params)       => api.get('/fil/posts', { params }),
  getPost:         (id)           => api.get(`/fil/posts/${id}`),
  unfurl:          (url)          => api.get('/fil/unfurl', { params: { url } }),
  createPost:      (data)         => api.post('/fil/posts', data),
  presignMedia:    (id, data)     => api.post(`/fil/posts/${id}/medias/presign`, data),
  confirmMedias:   (id, medias)   => api.post(`/fil/posts/${id}/medias/confirm`, { medias }),
  publier:         (id)           => api.post(`/fil/posts/${id}/publier`),
  updatePost:      (id, data)     => api.put(`/fil/posts/${id}`, data),
  removePost:      (id)           => api.delete(`/fil/posts/${id}`),
  reagir:          (id, emoji)    => api.put(`/fil/posts/${id}/reaction`, { emoji }),
  getCommentaires: (id)           => api.get(`/fil/posts/${id}/commentaires`),
  addCommentaire:  (id, texte)    => api.post(`/fil/posts/${id}/commentaires`, { texte }),
  removeCommentaire: (id)         => api.delete(`/fil/commentaires/${id}`),
};

export default filApi;
